import Vue from 'vue'
import PdfMake from 'pdfmake'
import pdfFonts from "pdfmake/build/vfs_fonts";
import moment from 'moment';
import $ from 'jquery';
import QRious from 'qrious'
import axios from 'axios'

Vue.mixin({
  data() {
    return {
      notifications: []
    }
  },
  components: {
    moment,
    QRious,
    axios,
    PdfMake
  },
  methods: {
    getNotification(){
      axios.get('notification')
      .then((response) => {
        this.notifications = response.data.data;
      })
      .catch((error) => {
      })
    },
    capitalizeFirstLetter(str) {
        return str.charAt(0).toUpperCase() + str.slice(1);
    },
    formatDateSimple(value){
      if (value) {
        moment.locale('id');
        return moment(String(value)).format('DD-MM-YYYY HH:mm')
      }
    },
    money(money){
      var formatter = new Intl.NumberFormat('id-ID', {
        style: 'currency',
        currency: 'IDR',
      });

      return formatter.format(money);
    },
    downloadReport(submissionId){
      axios({
        method: 'get',
        url: 'submission/detail/'+submissionId
      }).then(response => {
        if (response.status === 200) {
          var dataLoad = response.data.data;
          console.log(dataLoad);
          this.downloadPdf(dataLoad);
        } 
      }, error => {
        this.$swal({
          icon: 'warning',
          html: 'Data tidak ditemukan, akan dialihkan ke halaman isian',
          showConfirmButton: false,
          showCloseButton: true,
          showCancelButton: true,
          cancelButtonText: 'Kembali',
        });
      });
    },
    getPlural(number, word) {
      return number === 1 && word.one || word.other;
    },
    getWords(monthCount) {
      var months = { one: 'bulan', other: 'bulan' },
      years = { one: 'tahun', other: 'tahun' },
      m = monthCount % 12,
      y = Math.floor(monthCount / 12),
      result = [];

      y && result.push(y + ' ' + this.getPlural(y, years));
      m && result.push(m + ' ' + this.getPlural(m, months));
      return result.join(' ');
    },
    downloadPdf(dataRaw){
      let self = this;
      var isPositiveQualification = 'Berdasarkan hasil pemeriksaan forensik/laboratorium terdakwa dinyatakan positif menggunakan narkotika'
      var isUserQualification = 'Terdakwa merupakan end-user dan bukan bagian dari jaringan peredaran gelap narkotika'
      var tableHeader = [];
      var lampiran = dataRaw.articleList[0].codex=='TERM1'?'Lampiran 1':'Lampiran 2';
      // tableHeader.push([{ text: 'Detail Putusan', bold: true, fontSize: 14, colSpan:2, fillColor: '#E5E5E5'} ]);

      tableHeader.push([{ text: 'Pasal', bold: true, fontSize: 12},{ text: dataRaw.articleId, fontSize: 12} ]);
      tableHeader.push([{ text: 'Lampiran', bold: true, fontSize: 12},{ text: lampiran, fontSize: 12} ]);
      tableHeader.push([{ text: 'Pasal Lainnya', bold: true, fontSize: 12},{ text: dataRaw.relatedArticle , fontSize: 12} ]);
      tableHeader.push([{ text: 'Penyertaan', bold: true, fontSize: 12},{ text: dataRaw.isAddition==1?'Pasal 55 KUHP':'Tidak ada' , fontSize: 12} ]);
      tableHeader.push([{ text: 'Kumulasi', bold: true, fontSize: 12},{ text: dataRaw.isCumulative==1?'Ada kumulasi':'Tidak ada' , fontSize: 12} ]);

      var tableDefendant = [];
      // tableDefendant.push([{ text: 'Terdakwa', bold: true, fontSize: 14, colSpan:2, fillColor: '#E5E5E5'} ]);
      tableDefendant.push([{ text: 'Nama Terdakwa', bold: true, fontSize: 12},{ text: dataRaw.defendantId.fullName, fontSize: 12} ]);
      tableDefendant.push([{ text: 'Jenis Kelamin', bold: true, fontSize: 12},{ text: dataRaw.defendantId.sex, fontSize: 12} ]);
      tableDefendant.push([{ text: 'Umur', bold: true, fontSize: 12},{ text: dataRaw.defendantId.age, fontSize: 12} ]);
      tableDefendant.push([{ text: 'Pendidikan', bold: true, fontSize: 12},{ text: dataRaw.defendantId.education, fontSize: 12} ]);
      tableDefendant.push([{ text: 'Alamat', bold: true, fontSize: 12},{ text: dataRaw.defendantId.address, fontSize: 12} ]);
      tableDefendant.push([{ text: 'Status Penahanan', bold: true, fontSize: 12},{ text: dataRaw.isArrested==1?'Ditahan':'Tidak ditahan', fontSize: 12} ]);
      if(dataRaw.isPositiveQualification==1){
        tableDefendant.push([{ text: '', bold: true, fontSize: 12},{ text: isPositiveQualification, fontSize: 12} ]);
      }
      if(dataRaw.isUserQualification==1){
        tableDefendant.push([{ text: '', bold: true, fontSize: 12},{ text: isUserQualification, fontSize: 12} ]);
      }

      var tableNarcotics = [];
      tableNarcotics.push([
        { text: 'Nama', bold: true, fontSize: 12},
        { text: 'Gol.', bold: true, fontSize: 12, alignment:'center'},
        { text: 'Jenis', bold: true, fontSize: 12, alignment:'center'},
        { text: 'Berat', bold: true, fontSize: 12, alignment:'center'},
      ]); 
      dataRaw.narcoticEntries.forEach(function(item){
        tableNarcotics.push([
          { text: item.narcoticId.title+(item.narcoticId.chemicalName!=null?'\n'+item.narcoticId.chemicalName:''), fontSize: 12},
          { text: item.narcoticId.classification, fontSize: 12, alignment:'center'},
          { text: item.narcoticId.datagroup, fontSize: 12, alignment:'center'},
          { text: item.actualQuantity+' '+item.uom, fontSize: 12, alignment:'center'},
        ]);
      });

      var tableObjective = [];
      var tableObjectiveClean = [];
      dataRaw.objectiveEntries.forEach(function(item, index){
        // tableObjective.push([
        //   { text: item.selectedObjectiveId.objectiveTitle, fontSize: 12},
        // ]);

        if(tableObjectiveClean[item.articleId.articleName] == null){
          tableObjectiveClean[item.articleId.articleName] = [];
        }
        tableObjectiveClean[item.articleId.articleName][index] = item;
      });

      Object.keys(tableObjectiveClean).forEach(function(key) {
        tableObjective.push([{ text: key, fontSize: 12, bold: true, fillColor: '#E5E5E5'}]);
        tableObjectiveClean[key].forEach(function(item2, index2){
          tableObjective.push([{ text: item2.selectedObjectiveId.objectiveTitle, fontSize: 12}]);
        });
      });
      if(tableObjective.length < 1){
        tableObjective.push([{ text: '-', fontSize: 12}]);
      }

      var tableSubjective = [];
      dataRaw.subjectiveEntries.forEach(function(item){
        tableSubjective.push([{ text: item.selectedSubjectiveId.subjectiveTitle, fontSize: 12}]);
      });
      if(tableSubjective.length < 1){
        tableSubjective.push([{ text: '-', fontSize: 12}]);
      }

      var tableRentang = [];
      dataRaw.narcoticObjectiveFormula.forEach(function(item){
        var otherPenalty = '';

        if(item.deathPenalty==1){
          otherPenalty = otherPenalty + ' / Hukuman Mati'; 
        }
        if(item.lifetimePenalty==1){
          otherPenalty = otherPenalty + ' / Penjara Seumur Hidup'; 
        }
        tableRentang.push([
          { text: 'Pasal', fontSize: 12, bold: true , fillColor: '#E5E5E5'},{ text: item.articleId.articleName, fillColor: '#E5E5E5', fontSize: 12, bold: true}],[
          { text: 'Bobot Narkotika', fontSize: 12, bold: true},{ text: item.narcoticWeight, fontSize: 12, bold: true}],[
          { text: 'Bobot Kategori', fontSize: 12, bold: true},{ text: Math.round(item.objectiveWeight), fontSize: 12, bold: true}],[
          { text: 'Kategori Klasifikasi', fontSize: 12, bold: true},{ text: item.narcoticsCategory+'.'+item.objectiveCategory, fontSize: 12}],[
          { text: 'Denda', fontSize: 12, bold: true},{ text: self.money(item.fineMin)+' - '+self.money(item.fineMax), fontSize: 12}],[
          { text: 'Penjara', fontSize: 12, bold: true},{ text: item.imprisonedLength+' '+(item.imprisonedLengthUom=='month'?'bulan':item.imprisonedLengthUom)+otherPenalty, fontSize: 12}],[
          { text: 'Detail', fontSize: 12, bold: true},{ text: item.formulaTitle, fontSize: 12},
        ]);
      });
      if(tableRentang.length < 1){
        tableRentang.push([{ text: '-', fontSize: 12, colSpan : 2}]);
      }

      var tableKeadaan = [];
      var tableKeadaanCols = [ 120, '*' ];
      if(dataRaw.articleList[0].codex == 'TERM1'){
        dataRaw.circumstanceEntries.forEach(function(item){
          if(item.classification == '1'){
            tableKeadaan.push([{ text: 'Memberatkan', fontSize: 12, bold: true},{ text: item.textValue, fontSize: 12}]);
          } else {
            tableKeadaan.push([{ text: 'Meringankan', fontSize: 12, bold: true},{ text: item.textValue, fontSize: 12}]);
          }
        });

        if(tableKeadaan.length < 1){
          tableKeadaan.push([{ text: '-', fontSize: 12, colSpan : 2}]);
        }
      } else {
        tableKeadaanCols = [ '*' ];
        tableKeadaan.push([{ text: 'Memberatkan', fontSize: 12, bold: true}]);
        dataRaw.circumstanceEntries.filter(a => a.selectedCircumstanceId.questionModel != 'TEXT').forEach(function(item){
          if(item.classification == '1'){
            tableKeadaan.push([{ text: item.selectedCircumstanceId.circumstanceTitle, fontSize: 12}]);
          }
        });
        dataRaw.circumstanceEntries.filter(a => a.selectedCircumstanceId.questionModel == 'TEXT').forEach(function(item){
          if(item.classification == '1'){
            tableKeadaan.push([{ text: "Alasan Lainnya: "+item.textValue, fontSize: 12}]);
          }
        });
        tableKeadaan.push([{ text: 'Meringankan', fontSize: 12, bold: true}]);
        dataRaw.circumstanceEntries.filter(a => a.selectedCircumstanceId.questionModel != 'TEXT').forEach(function(item){
          if(item.classification == '2'){
            tableKeadaan.push([{ text: item.selectedCircumstanceId.circumstanceTitle, fontSize: 12}]);
          }
        });
        dataRaw.circumstanceEntries.filter(a => a.selectedCircumstanceId.questionModel == 'TEXT').forEach(function(item){
          if(item.classification == '2'){
            tableKeadaan.push([{ text: "Alasan Lainnya: "+item.textValue, fontSize: 12}]);
          }
        });

        if(tableKeadaan.length < 1){
          tableKeadaan.push([{ text: '-', fontSize: 12}]);
        }
      }

      var tableKeadaanSpc = [];
      var tableKeadaanSpcCols = [ '*' ];
      tableKeadaanSpc.push([{ text: 'Memberatkan', fontSize: 12, bold: true}]);
      var isFound = false;
      dataRaw.circumstanceEntriesSpecial.forEach(function(item){
        if(item.classification == '1'){
          isFound = true;
          tableKeadaanSpc.push([{ text: item.selectedCircumstanceId.circumstanceTitle, fontSize: 12}]);
        }
      });
      if(!isFound){
        tableKeadaanSpc.push([{ text: '-', fontSize: 12}]);
      }
      tableKeadaanSpc.push([{ text: 'Meringankan', fontSize: 12, bold: true}]);
      var isFoundRingan = false;
      dataRaw.circumstanceEntriesSpecial.forEach(function(item){
        if(item.classification == '2'){
          isFoundRingan = true;
          tableKeadaanSpc.push([{ text: item.selectedCircumstanceId.circumstanceTitle, fontSize: 12}]);
        }
      });
      if(!isFoundRingan){
        tableKeadaanSpc.push([{ text: '-', fontSize: 12}]);
      }

      var tableResult = [];
      if(dataRaw.finalResult != null){
        if(dataRaw.finalResult.conditionalState1 == '1' || dataRaw.finalResult.conditionalState2 == '1'){
          var state1 = '';
          if(dataRaw.finalResult.conditionalState1 == '1'){
            state1 = 'Terdakwa belum pernah dipidana melakukan tindak pidana narkotika dan/atau prekursor narkotika; dan/atau';
            tableResult.push(
              [{ text: '', fontSize: 12},{ text: state1, fontSize: 12}]
            ); 
          }
          var state2 = '';
          if(dataRaw.finalResult.conditionalState2 == '1'){
            state2 = 'Terdakwa tidak berada di bawah pengaruh narkotika ketika menjalankan pekerjaan yang berkaitan dengan:\n'+
              '1) keselamatan, antara lain di bidang transportasi dan kesehatan; atau\n'+
              '2) pendidikan';
            tableResult.push(
              [{ text: '', fontSize: 12},{ text: state2, fontSize: 12}]
            ); 
          }
          tableResult.push(
            [{ text: 'Pidana Bersyarat', bold: true, fontSize: 12},{ text: dataRaw.finalResult.conditionalImprisonment+ ' bulan', fontSize: 12}]
          ); 
        }
        if(dataRaw.finalResult.finalRehabilitationImprisonment == null || dataRaw.finalResult.finalRehabilitationImprisonment == "0"){}else{
          tableResult.push(
            [{ text: 'Lama Rehabilitasi', bold: true, fontSize: 12},{ text: dataRaw.finalResult.finalRehabilitationImprisonment+ ' bulan', fontSize: 12}],
            [{ text: 'Lokasi Rehabilitasi', bold: true, fontSize: 12},{ text: dataRaw.finalResult.finalRehabilitationLocation, fontSize: 12}],
            [{ text: '\n',colSpan:2}]
          ); 
        }
        tableResult.push(
          [{ text: 'Pemidanaan', bold: true, fontSize: 12},{ text: dataRaw.finalResult.finalPointment=='REHABILITATION'?'Rehabilitasi':dataRaw.finalResult.finalPointment, fontSize: 12}],
          [{ text: 'Jenis Pidana', bold: true, fontSize: 12},{ text: dataRaw.finalResult.finalHeavyPointment, fontSize: 12}],
          [{ text: 'Pidana Penjara', bold: true, fontSize: 12},{ text: (dataRaw.finalResult.finalImprisonment==null?'0':dataRaw.finalResult.finalImprisonment)+ ' bulan / '+this.getWords(dataRaw.finalResult.finalImprisonment), fontSize: 12}],
          [{ text: 'Denda', bold: true, fontSize: 12},{ text: this.money(dataRaw.finalResult.finalFine), fontSize: 12}]
        ); 
      }
      if(tableResult.length < 1){
        tableResult.push([{ text: '-', fontSize: 12, colSpan: 2}]);
      }

      var tableResultCorrection = [];
      if(dataRaw.finalResult != null){
        if(tableKeadaanSpc.length < 1){
          tableResultCorrection.push(
            [{ text: 'Pidana Penjara', bold: true, fontSize: 12},{ text: (dataRaw.finalResult.finalImprisonment==null?'0':dataRaw.finalResult.finalImprisonment)+ ' bulan / '+this.getWords(dataRaw.finalResult.finalImprisonment), fontSize: 12}],
            [{ text: 'Denda', bold: true, fontSize: 12},{ text: this.money(dataRaw.finalResult.finalFine), fontSize: 12}]
          ); 
        } else {
          tableResultCorrection.push(
            [{ text: 'Pidana Penjara', bold: true, fontSize: 12},{ text: (dataRaw.finalResult.finalImprisonmentCorrection==null?'0':dataRaw.finalResult.finalImprisonmentCorrection)+ ' bulan / '+this.getWords(dataRaw.finalResult.finalImprisonmentCorrection), fontSize: 12}],
            [{ text: 'Denda', bold: true, fontSize: 12},{ text: this.money(dataRaw.finalResult.finalFineCorrection), fontSize: 12}]
          ); 
        }
      }
      if(tableResultCorrection.length < 1){
        tableResultCorrection.push([{ text: '-', fontSize: 12, colSpan: 2}]);
      }

      var qr = new QRious();
      qr.level = 'L';
      qr.size = 80; 
      qr.value = 'https://pedomantut.com/submission/'+btoa(dataRaw.id);

      var docDefinition = {
        content: [
          { text: 'Pedoman Tuntutan', fontSize: 15 },
          { text: '\n'},
          { text: 'Nomor Sistem : '+dataRaw.letterNumber, fontSize: 12 },
          { text: 'Nomor Dakwaan : '+dataRaw.documentNumber, fontSize: 12 },
          { text: 'Rencana Tuntutan : '+dataRaw.title, fontSize: 12 },
          { text: 'Tanggal : '+this.formatDateSimple(dataRaw.createdDate), fontSize: 12 },
          { text: 'Status : '+(dataRaw.status=='SUBMIT'?'Draft':dataRaw.status=='COMPLETED'?'Selesai':dataRaw.status), fontSize: 12 },
          { text: '\n'},
          {
            table: {
              widths: [ 120 , '*' ],
              body: tableHeader
            }
          },
          { text: '\n'},
          { text: '1. Terdakwa', fontSize: 12, bold: true, lineHeight : 1.5 },
          {
            table: {
              widths: [ 120 , '*' ],
              body: tableDefendant
            }
          },
          { text: '\n'},
          { text: '2. Data Narkotika', fontSize: 12, bold: true, lineHeight : 1.5 },
          {
            table: {
              widths: [ '*' , 25, 55, 60 ],
              body: tableNarcotics
            }
          },
          { text: '\n'},
          { text: '3. Klasifikasi Subjektif', fontSize: 12, bold: true, lineHeight : 1.5 },
          {
            table: {
              widths: [ '*' ],
              body: tableSubjective
            }
          },
          { text: '\n'},
          { text: '4. Klasifikasi Objektif', fontSize: 12, bold: true, lineHeight : 1.5 },
          {
            table: {
              widths: [ '*' ],
              body: tableObjective
            }
          },
          { text: '\n'},
          { text: '5. Rentang Tuntutan', fontSize: 12, bold: true, lineHeight : 1.5 },
          {
            table: {
              widths: [ 120, '*' ],
              body: tableRentang
            }
          },
          { text: '\n'},
          { text: '6. Keadaan', fontSize: 12, bold: true, lineHeight : 1.5 },
          {
            table: {
              widths: tableKeadaanCols,
              body: tableKeadaan
            }
          },
          { text: '\n'},
          { text: '7. Keadaan Khusus', fontSize: 12, bold: true, lineHeight : 1.5 },
          {
            table: {
              widths: tableKeadaanSpcCols,
              body: tableKeadaanSpc
            }
          },
          { text: '\n'},
          { text: '8. Besar Tuntutan', fontSize: 12, bold: true, lineHeight : 1.5 },
          {
            table: {
              widths: [ 120, '*' ],
              body: tableResult
            }
          },
          { text: '\n'},
          { text: '9. Besar Tuntutan - Setelah Menimbang Keadaan', fontSize: 12, bold: true, lineHeight : 1.5 },
          {
            table: {
              widths: [ 120, '*' ],
              body: tableResultCorrection
            }
          },
          { text: '\n'},
          { text: '\n'},
          { text: 'Dibuat Oleh : '+dataRaw.createdBy.name, italics: true, fontSize: 11},
          { text: 'Dibuat Tanggal : '+this.formatDateSimple(dataRaw.createdDate), italics: true, fontSize: 11},
          { text: 'Diperbarui Oleh : '+dataRaw.updatedBy.name, italics: true, fontSize: 11},
          { text: 'Diperbarui Tanggal : '+this.formatDateSimple(dataRaw.updatedDate), italics: true, fontSize: 11},
          { text: '\n'},
          { image: qr.toDataURL() },
          { text: '\n'},
          { text: 'Dokumen ini dibuat secara elektronik oleh sistem pedomantut.com', italics: true, fontSize: 11},
          { text: 'Tanggal diunduh: '+this.formatDateSimple(new Date()), italics: true, fontSize: 11},
          { text: '\n'},
        ],
        styles: {
         
        }
      };
      const PdfFile = PdfMake.createPdf(docDefinition, null, null, pdfFonts.pdfMake.vfs);
      PdfFile.download();
    }, 
  }
})